import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { LeverageTokenInfoSummaryComponent } from "./leverage-token-info-summary.component";

@NgModule({
	declarations: [LeverageTokenInfoSummaryComponent],
	imports: [CoreModule],
	exports: [LeverageTokenInfoSummaryComponent]
})
export class LeverageTokenInfoSummaryModule {}
